import CalamitiesPageView from "./CalamitiesPageView"

function CalamitiesPage() {
    return <CalamitiesPageView />
}

export default CalamitiesPage;